import type SceneControl from '../scene/scene'

const useScene = (sceneControl: SceneControl) => {
  return sceneControl.context
}

export default useScene
